import { render, staticRenderFns } from "./zzyList.vue?vue&type=template&id=cd8c8e3e&scoped=true"
import script from "./zzyList.vue?vue&type=script&lang=js"
export * from "./zzyList.vue?vue&type=script&lang=js"
import style0 from "./zzyList.vue?vue&type=style&index=0&id=cd8c8e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8c8e3e",
  null
  
)

export default component.exports